import { render, staticRenderFns } from "./DayOff.vue?vue&type=template&id=e4e12c40"
import script from "./DayOff.vue?vue&type=script&lang=js"
export * from "./DayOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports